import cn from 'classnames';
import React from 'react';
import './CheckboxContainer.css';

/**
 * This is a container for a single row, which contains a checkbox. The checkbox size messes up
 * the spacing around the row since it forces extra padding. Thus elements around this container have a harder time
 * having the proper
 * that's there because of the checkbox, OR the container of the checkbox must take care of that extra space
 * */
export default ({ children, className }) => <div className={cn('CheckboxContainer', className)}>
    {children}
</div>;
